import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalLandPlatformService } from '@sp401/modal-engine';
import { ToastObject } from 'src/app/interfaces/toast-object';
import { TranslationService } from 'src/app/services/translation.service';
import { UtilService } from 'src/app/services/util.service';
import {AssetPipe} from "../../pipes/asset.pipe";

@Component({
  selector: 'user-message-modal',
  standalone: true,
  imports: [CommonModule, AssetPipe],
  templateUrl: './user-message-modal.component.html',
  styleUrl: './user-message-modal.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None
})
export class UserMessageModalComponent implements OnInit {
  translationUserProfile: any;
  title: any;
  description: any;
  messageInfo: ToastObject | undefined;
  translation: any;

  toastIcon: any = {
    Success: 'green-check',
    Error: 'alertIcon',
    Alert: 'alertIcon'
  }

  toastIconCss: any = {
    Success: 'success-icon',
    Error: 'error-icon',
    Alert: 'alert-icon'
  }

  constructor(
    private _modal: ModalLandPlatformService,
    private utilService: UtilService,
    private translationService: TranslationService
  ) {

  }

  ngOnInit() {
    this.translation = this.translationService.getTranslationForPage('userProfile');
    this.utilService.popupMessageInfo$.subscribe((messageInfo: ToastObject) => {

      this.messageInfo = messageInfo;
    });
  }

  close() {
    this._modal.triggerCloseModal('user_message_modal');
  }
}
